module.exports = __webpack_public_path__ + "static/misija-vizija-50b8b9293b23475dbc8df6c8c1bb1767.png";